import styled from 'styled-components'
import {deviceMax} from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'

export const StyledModal = styled.div`
  z-index: 50;
  position: fixed;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: ${({theme}) => theme.colors.opacity.black80};
`

export const InvisibleButton = styled.button`
  position: absolute;
  bottom: ${pxToRem(30)};
  left: ${pxToRem(53)};
  border: none;
  width: ${pxToRem(91)};
  height: ${pxToRem(50)};
  background-color: ${({theme}) => theme.colors.unique.transparent};
  cursor: pointer;
  @media ${deviceMax.mobileL} {
    bottom: ${pxToRem(32)};
    left: ${pxToRem(13)};
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: ${pxToRem(-19)};
  right: ${pxToRem(-19)};
  border: none;
  width: ${pxToRem(39)};
  height: ${pxToRem(39)};
  background-color: ${({theme, $invisible}) =>
          $invisible ? theme.colors.unique.white : theme.colors.unique.transparent};
  box-sizing: border-box;
  box-shadow: 0 ${pxToRem(3)} ${pxToRem(10)} rgb(0 0 0 / 0.2);
  border-radius: 25px;
  cursor: pointer;
  z-index: 100;
`

export const StyledCard = styled.div`
  position: relative;
  width: fit-content;
  height: fit-content;
`

export const WhiteButton = styled.button`
  position: absolute;
  top: calc(50% - ${pxToRem(152)} + ${pxToRem(197)});
  left: calc(50% - ${pxToRem(45)});
  border: none;
  width: ${pxToRem(91)};
  height: ${pxToRem(50)};
  background-color: ${({theme, $invisible}) =>
          $invisible ? theme.colors.unique.white : theme.colors.unique.transparent};
  @media ${deviceMax.mobileL} {
    top: calc(50% - ${pxToRem(143)} + ${pxToRem(200)});
    left: calc(50% - ${pxToRem(150)});
  }
`

export const StyledIFrame = styled.iframe`
  border-radius: ${pxToRem(5)};
  width: ${pxToRem(660)};
  height: ${pxToRem(400)};
  @media ${deviceMax.mobileL} {
    height: ${pxToRem(600)};
    width: ${pxToRem(300)};
  }
`
